import * as React from 'react'
import { SbEditableBlok } from '@storyblok/storyblok-editable'
import { renderRichtext } from '../../lib/utils/renderRichtext'
import { Tabs } from '../../components/UI'
import { TabTeaserItem } from './Item'
import { StyledTabTeaserCard, StyledTabTeaserWrapper } from './styled'

export const TabTeaserModule = ({ blok }: { blok: SbEditableBlok }) => {
  const { autoplay_on: autoplay } = blok
  const [theme, setTheme] = React.useState<string | undefined>()

  const tabs = blok.tabs.map(tab => {
    const newTab = {
      ...tab,
      content: renderRichtext(tab.content),
    }

    if (tab.image?.filename) {
      // newTab.image = resize(tab.image.filename, 500)
      newTab.image = tab.image.filename
    } else {
      newTab.image = undefined
    }

    return newTab
  })

  return (
    <StyledTabTeaserWrapper>
      <StyledTabTeaserCard className={theme}>
        <Tabs.Wrapper autoplay={autoplay}>
          <Tabs.Navigation position="center">
            {tabs.map((tab, i) => (
              <Tabs.NavigationItem key={i} tabId={i.toString()}>
                {tab.label}
              </Tabs.NavigationItem>
            ))}
          </Tabs.Navigation>
          <Tabs.Content>
            {tabs.map((tab, i) => (
              <TabTeaserItem setTheme={setTheme} key={i} tab={tab} tabId={i.toString()}>
                {tab.content}
              </TabTeaserItem>
            ))}
          </Tabs.Content>
        </Tabs.Wrapper>
      </StyledTabTeaserCard>
    </StyledTabTeaserWrapper>
  )
}
